'use client';

import React, { useEffect, useState } from 'react';
import { BookOpenIcon } from '@heroicons/react/24/outline';
import { getVersiculoDelDia } from '../../services/versiculoDelDiaService';
import type { VersiculoDelDia as VersiculoType } from '../../types';

interface VersiculoDelDiaProps {
  variant?: 'login' | 'dashboard';
  showEnglish?: boolean;
}

export function VersiculoDelDia({ variant = 'dashboard', showEnglish = false }: VersiculoDelDiaProps) {
  const [versiculo, setVersiculo] = useState<VersiculoType | null>(null);
  const [loading, setLoading] = useState(true);
  const [mostrarIngles, setMostrarIngles] = useState(showEnglish);

  useEffect(() => {
    getVersiculoDelDia()
      .then((v) => {
        setVersiculo(v);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <div className={`animate-pulse rounded-xl bg-blue-50 ${variant === 'login' ? 'p-4' : 'p-5'}`}>
        <div className="h-4 bg-blue-200 rounded w-3/4 mb-2" />
        <div className="h-3 bg-blue-100 rounded w-1/2" />
      </div>
    );
  }

  if (!versiculo) return null;

  if (variant === 'login') {
    return (
      <div className="w-full bg-gradient-to-r from-blue-50 to-blue-100 border border-blue-200 rounded-xl p-4 mb-6">
        <div className="flex items-start gap-3">
          <div className="mt-0.5 flex-shrink-0">
            <BookOpenIcon className="w-5 h-5 text-blue-600" />
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-xs font-semibold text-blue-700 uppercase tracking-wider mb-1">
              Verso del Día · Emprendedores de Fe
            </p>
            <p className="text-sm text-gray-800 leading-snug italic">
              &quot;{versiculo.texto_es}&quot;
            </p>
            <p className="text-xs font-semibold text-blue-600 mt-1.5">
              — {versiculo.ref_es}
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="w-full rounded-2xl border border-gray-100 bg-white px-4 py-3 shadow-sm flex items-center gap-3">
      <div className="h-9 w-9 rounded-xl bg-blue-50 flex items-center justify-center shrink-0">
        <BookOpenIcon className="w-5 h-5 text-[#1A56DB]" />
      </div>
      <div className="min-w-0 flex-1">
        <p className="text-[11px] font-semibold uppercase tracking-wider text-gray-400">Verso del día</p>
        {mostrarIngles ? (
          <p className="text-sm text-[#0B1F4A] italic truncate">
            &quot;{versiculo.texto_en}&quot; — {versiculo.ref_en}
          </p>
        ) : (
          <p className="text-sm text-[#0B1F4A] italic truncate">
            &quot;{versiculo.texto_es}&quot; — {versiculo.ref_es}
          </p>
        )}
      </div>
      <button
        type="button"
        onClick={() => setMostrarIngles(!mostrarIngles)}
        className="shrink-0 text-sm font-medium text-[#1A56DB] hover:underline"
      >
        Ver más
      </button>
    </div>
  );
}
